import React, { useEffect, useMemo, useState } from 'react';

import { Autocomplete, TextField } from '@mui/material';

// eslint-disable-next-line unused-imports/no-unused-imports
import BedbankService from '~/services/BedbankService';

interface Props {
  value: string;
  onChange: (newValue: string) => void;
  onFocus?: () => void;
}

export default function AccommodationChainNameFilterInput({ value, onChange, onFocus }: Props) {
  const [chainNames, setChainNames] = useState<string[]>([]);

  useEffect(() => {
    BedbankService.getChains().then((res) => setChainNames(res.result));
  }, []);

  const sortedChainNames = useMemo(() => [...chainNames].sort(), [chainNames]);

  return (
    <Autocomplete
      options={sortedChainNames}
      value={value || null}
      onChange={(_, newValue) => onChange(newValue ?? '')}
      renderInput={(params) => <TextField {...params} label="Chain Name" onFocus={onFocus} />}
      fullWidth
      openOnFocus
      clearOnEscape
    />
  );
}
